import { makeStyles } from '@material-ui/core';

import palette from '../../theme/palette';

export default makeStyles(theme => ({
  root: {
    minHeight: '100vh',
    height: '100%',
    backgroundColor: palette.backgrounds.dark
  },
  container: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(4)
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1)
  },
  button: {
    width: theme.spacing(25),
    marginRight: theme.spacing(0.5),
    padding: theme.spacing(1),
    borderRadius: theme.spacing(6),
    color: palette.white,
    backgroundColor: palette.buttons.purple,
    fontWeight: 700,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: palette.primary.lighter
    },
    '&.Mui-disabled': {
      color: palette.white,
      backgroundColor: palette.common.grayAvatar
    }
  },
  pdfContainer: {
    height: '100%',
    width: '100%',
    borderRadius: theme.spacing(1.5),
    backgroundColor: palette.backgrounds.light,
    [theme.breakpoints.down('sm')]: {
      minHeight: '80vh'
    }
  },
  editablePanel: {
    minHeight: '50vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  pdfEma: {
    minHeight: '75vh',
    border: 0,
    borderRadius: theme.spacing(1.5)
  },
  formSection: {
    minHeight: '50vh',
    maxHeight: '75vh',
    overflowY: 'auto',
    padding: theme.spacing(2, 0)
  },
  labelRow: {
    width: '90%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    margin: theme.spacing(2, 'auto')
  },
  labelText: {
    width: '45%',
    marginRight: theme.spacing(2),
    color: palette.white,
    textTransform: 'capitalize'
  },
  textField: {
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(0.5),
    borderRadius: theme.spacing(1.5),
    backgroundColor: palette.backgrounds.dark
  },
  input: {
    marginLeft: theme.spacing(1),
    color: `${palette.white} !important`,
    fontSize: theme.spacing(1.5),
    [theme.breakpoints.down('xl')]: {
      fontSize: theme.spacing(2)
    }
  },
  notAvailable: {
    color: palette.white,
    fontSize: theme.spacing(3),
    fontWeight: 700
  },
  note: {
    width: '80%',
    margin: theme.spacing(1, 'auto'),
    color: palette.white
  },
  loadingRoot: {
    width: '100%',
    height: '80vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  loadingBar: {
    width: '100%',
    maxWidth: 400,
    marginBottom: theme.spacing(2)
  }
}));
